__turbopack_context__.v({
  "aavattoLink": "footer-module__DeADUW__aavattoLink",
  "aavattoLogo": "footer-module__DeADUW__aavattoLogo",
  "bottomBar": "footer-module__DeADUW__bottomBar",
  "bottomBarInner": "footer-module__DeADUW__bottomBarInner",
  "brandCol": "footer-module__DeADUW__brandCol",
  "colTitle": "footer-module__DeADUW__colTitle",
  "contactCol": "footer-module__DeADUW__contactCol",
  "contactIcon": "footer-module__DeADUW__contactIcon",
  "contactItem": "footer-module__DeADUW__contactItem",
  "contactList": "footer-module__DeADUW__contactList",
  "copyright": "footer-module__DeADUW__copyright",
  "copyrightNotice": "footer-module__DeADUW__copyrightNotice",
  "footer": "footer-module__DeADUW__footer",
  "footerGrid": "footer-module__DeADUW__footerGrid",
  "footerLink": "footer-module__DeADUW__footerLink",
  "linkCol": "footer-module__DeADUW__linkCol",
  "linksGroup": "footer-module__DeADUW__linksGroup",
  "logoImg": "footer-module__DeADUW__logoImg",
  "logoLink": "footer-module__DeADUW__logoLink",
  "loveIcon": "footer-module__DeADUW__loveIcon",
  "madeWith": "footer-module__DeADUW__madeWith",
  "socialIcon": "footer-module__DeADUW__socialIcon",
  "socialRow": "footer-module__DeADUW__socialRow",
  "socialTagline": "footer-module__DeADUW__socialTagline",
});
